// Filtered lists keep hidden rows as siblings, so separators and rounded corners cannot come from
// `li + li` / `:last-child` — the visible ends are marked by hand and styled in _utilities.scss.
export default function markVisibleEdges(rows) {
  rows.forEach((row) => row.classList.remove('is-first-visible', 'is-last-visible'))

  const visible = rows.filter((row) => !row.hidden)
  if (visible.length === 0) return

  visible[0].classList.add('is-first-visible')
  visible[visible.length - 1].classList.add('is-last-visible')
}
